import React, { useEffect, useState } from "react";
import { LFTableV3 } from "../../../../../common/components/LFTable/LFTableV3";
import { useHolidayStore } from "../../store/HolidayStore";
import { ColumnItem } from "../../../../../common/models/table";
import { ActionsKey } from "../../../../../common/models/Actions";
import { WorkCalendarService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../../common/components/Loader/Loader";
import dayjs from "dayjs";

type PropsType = {
  onOpenAction?: () => void;
};

export const PublicHolidayList = ({ onOpenAction }: PropsType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cols: ColumnItem[] = [
    {
      key: "date",
      title: "Date",
      dataIndex: "date",
      show: true,
      isCanSort: true,
      // searchType: "text",
      render: (date: string) => (
        <div>
          {date
            ? dayjs(date, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "label",
      title: "Titre",
      dataIndex: "label",
      show: true,
      isCanSort: true,
      // searchType: "text",
    },
  ];

  const {
    list,
    pageState,
    resetPageState,
    setActioned,
    setList,
    setPageState,
    totalItems,
  } = useHolidayStore();

  useEffect(() => {
    getLists(pageState);
  }, [pageState]);

  const getLists = async (params: any) => {
    try {
      setIsLoading(true);

      const res = await WorkCalendarService.getHolydays(params);
      if (res?.status === HttpStatusCode.Ok) {
        setList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(item?.id);
    } else {
      setActioned({
        action,
        data: item,
      });
      onOpenAction && onOpenAction();
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);

      const res = await WorkCalendarService.deleteHoliday(id);
      if (
        res?.status === HttpStatusCode.Ok ||
        res?.status === HttpStatusCode.NoContent
      ) {
        getLists(pageState);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...pageState,
      ...params,
    });
  };
  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <LFTableV3
        columns={cols}
        data={list}
        params={pageState}
        onAction={onActionClick}
        isCanEdit={() => true}
        isCanDelete={() => true}
        onSearch={handleSetParams}
        onSort={handleSetParams}
        onResetSearch={resetPageState}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
        onChangePage={handleSetParams}
      />
    </div>
  );
};
